// extracted by mini-css-extract-plugin
export default {"melodyVideo":"zJ-z","isFullWidth":"AJ-z","landingPageVideo":"BJ-z","play":"CJ-z","iframeVideo":"DJ-z","playHidden":"EJ-z","fullwidth":"FJ-z"};